// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3K87m","content":"styles_content__2B87V","selectAll":"styles_selectAll__3g1kk"};